<template>
  <div class="card">
    <div class="card--header">{{ $t("workspace.organizations-accessible") }}</div>
    <div class="wrapper" v-if="pagination">
      <div class="card--item" v-for="item in pagination.docs" :key="item._id">
        <div class="card--item--photo rounded-circle">
          <img :src="item.logo" alt="" />
        </div>
        <div>
          <div class="card--item--name">{{ item.name }}</div>
        </div>

        <div class="dropdown-icon">
          <b-dropdown id="workspace-member-dropdown" variant="link" no-caret>
            <template #button-content>
              <div class="mdi mdi-dots-horizontal icon"></div>
            </template>
            <b-dropdown-item>
              <div @click="selectOrganizationAndGo(item, '/organization')">
                {{ $t("organization.panel") }}
              </div>
            </b-dropdown-item>
            <b-dropdown-item>
              <div @click="selectOrganizationAndGo(item, '/gdpr/roadmap')">
                {{ $t("product.gdpr.product") }}
              </div>
            </b-dropdown-item>
            <b-dropdown-item>
              <div @click="selectOrganizationAndGo(item, '/kvkk/roadmap')">
                {{ $t("product.kvkk.product") }}
              </div>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>

    <content-loading v-if="loading" />

    <empty v-if="!loading && (!pagination || pagination.docs.length == 0)">
      <h5 class="text-center" id="myText">
        {{ $t("common.not-found") }}
      </h5>
    </empty>
    <br v-if="!pagination || pagination.docs.length == 0" />

    <template v-if="pagination">
      <div class="d-flex justify-content-center my-3">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      request: {
        options: { page: 1, limit: 10, sort: { name: "asc" } },
        query: {},
      },
    };
  },

  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.paginate();
      },
    },
  },
  computed: {
    pagination() {
      return this.$store.getters["workspace/paginateWorkspaceOrganization"];
    },
    loading() {
      return this.$store.getters["workspace/isLoading"];
    },
  },
  methods: {
    paginate() {
      if (!this.currentWorkspace) {
        return;
      }
      this.$store.dispatch(`workspace/fetchWorkspaceOrganizations`, { request: this.request, id: this.currentWorkspace?._id });
    },
  },
};
</script>

<style scoped>
.icon {
  font-size: 20px;
  color: rgb(193 197 201);
  width: 1.8rem;
  height: 2rem;
  border-radius: 50%;
}
.icon:hover {
  background-color: #e7e7e8;
}
.dropdown-icon {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 2rem;
  height: 2rem;

  margin-left: auto;
  border-radius: 50%;
  cursor: pointer;
}
</style>
